
export const newsFeedConstant = {
    label: {
        EMAIL_BTN: 'Email',
        URL_BTN: 'URL/Link',
        HERO_HEADLINE: 'Hero Headline',
        HERO_BODY: 'Hero Body',
        HERO_URL_LINK: 'Hero URL/Link*',
        LINK_TEXT: 'Link Text*',
        SHOW_BUTTON: 'Show Hero Button',
        HERO_BUTTON_TEXT: 'Hero Button Text',
        UPDATE_IMAGE: 'Update Image*',
        DARKEN_IMAGE: 'Dark Image',
        IMAGE_GUIDELINE: 'Guideline for image size/content',
        REQUIRED_TO_SAVE: '*URL/Text/Image required to Save',
        IMAGE_NOT_LOADED: 'Invalid Image Location',
    },
    const: {
        maxHeadlineChar: 60,
        maxBodyChar: 120,
        maxUrlTextChar: 32,
        maxButtonChar: 32,
        maxFileSize: 1000000,
    },
    errors: {
        HEADLINE_REQUIRED: 'Headline is required',
        URL_LINK_REQUIRED: 'URL Link is required',
        EMAIL_REQUIRED: 'Email is required',
        URL_TEXT_REQUIRED: 'URL Text is required',
        BUTTON_TEXT_REQUIRED: 'Button Text is required',
        INVALID_URL: 'Please enter a valid URL/Link',
        INVALID_EMAIL: 'Please enter a valid Email',
        MAX_CHAR_LIMIT_EXCEEDED: 'Too many characters',
        IMAGE_TYPE_NOT_SUPPORTED: 'Image type not supported',
        FILE_SIZE_ERROR: 'The file is exceeding the maximum file size of 1MB.  Please try a new smaller file',
    },
};

export const imageGuidelinesConstants = {
    guidelines: [
    'Upload a background image, add a link and use the editor to add text to your image.',
    'Upload your own pre-designed creative following the guidelines below, then add a link.',
    ],
    GUIDELINES_TITLE: 'Two easy ways to create a hero post',
    GUIDELINE_WARNING: 'Make sure essential content appears inside the 700x350 safe area to ensure it’s visible on multiple devices.',
    RECOMMENDED_SIZE: 'Recommended Image Size: 1000x500',
};

export const additionalHeadline = (slotNum) => {
    return `Slot ${slotNum} Headline*`;
};

export const additionalLinkText = (slotNum) => {
    return `Slot ${slotNum} Link Text*`;
};

export const additionalUrl = (slotNum, type) => {
    let result = '';
    if (slotNum && type) {
        result = type === 'url' ? `Slot ${slotNum} URL/Link*` : `Slot ${slotNum} Email Address*`;
    }
    return result;
};
